import { z } from 'zod';
import { paginationSchema } from '~/components/Pagination/Pagination.schema';

export const querySchema = z
  .object({
    search: z.string().default(''),
    district: z
      .string()
      .default('')
      .transform(x => (x ? Number(x) : undefined)),
    club: z
      .string()
      .default('')
      .transform(x => (x ? Number(x) : undefined)),
    clubName: z.string().default(''),
  })
  .merge(paginationSchema);
